import { useState } from 'react';
import { FiChevronDown, FiClock, FiExternalLink } from 'react-icons/fi';
import { formatEther } from 'viem';
import { Video, Bet } from '../../hooks/useContracts';
import BetRow from '../BetRow/BetRow';
import './VideoGroupCard.scss';

interface VideoGroupCardProps {
  group: {
    video: Video & { id: bigint };
    bets: (Bet & { id: bigint })[];
    totalWagered: bigint;
  };
}

export default function VideoGroupCard({ group }: VideoGroupCardProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const { video, bets, totalWagered } = group;

  const now = Math.floor(Date.now() / 1000);
  const bettingDeadline = Number(video.bettingDeadline);
  const isResolved = video.isViewsSet;


  // Calculate time remaining
  const timeRemaining = bettingDeadline - now;
  const hours = Math.floor(timeRemaining / 3600);
  const minutes = Math.floor((timeRemaining % 3600) / 60);
  const timeText = timeRemaining > 0 ? `${hours}h ${minutes}m left` : 'Closed';



  return (
    <>
      <div className={`video-group-card ${isExpanded ? 'video-group-card--expanded' : ''}`}>
        <div className="video-group-card__header" onClick={() => setIsExpanded(!isExpanded)}>

          <video
            className="video-group-card__thumbnail"
            controls
            playsInline
            onClick={(e) => e.stopPropagation()}
          >
            {video.videoUrl && (
              <source 
                src={"https://"+video.videoUrl} 
                type="video/mp4"
              />
            )}
          </video>
          <div className="video-group-card__info">
            <a href={"https://"+video.postUrl || video.videoUrl} target="_blank" rel="noopener noreferrer"><p className='video-group-card__link'> Go to post <FiExternalLink size={14} /></p></a>
            <div className="video-group-card__meta">
              <span>•</span>
              <span className="flex items-center gap-1">
                <FiClock size={14} /> {timeText}
              </span>
              <span>•</span>
              <span>{bets.length} bet{bets.length !== 1 ? 's' : ''}</span>
            </div>
          </div>

          <div className="video-group-card__stats">
            <div className="video-group-card__stat">
              <div className="video-group-card__stat-label">Total Wagered</div>
              <div className="video-group-card__stat-value video-group-card__stat-value--highlight">
                {formatEther(totalWagered)} ETH
              </div>
            </div>

            <div className="video-group-card__toggle">
              <FiChevronDown />
            </div>
          </div>
        </div>

        {isExpanded && (
          <div className="video-group-card__body">
            <div className="video-group-card__bets-list">
              {bets.map((bet) => (
                <BetRow
                  key={Number(bet.id)}
                  bet={bet}
                  betId={bet.id}
                  isResolved={isResolved}
                  thresholds={video.thresholds}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
